export default "__VITE_ASSET__C$N844Gb__"